import { Directive } from '@angular/core';

import { ImmomioIconName, MasterdataChangeType } from '../../models';
import { RouterService } from '../../services';
import { ActivatedRoute } from '@angular/router';

@Directive()
export abstract class UserEditOverviewPageBaseComponent {
  public immomioIconName = ImmomioIconName;
  public closeButton: ImmomioIconName = ImmomioIconName.Close;
  public changeType: string;
  protected readonly MasterdataChangeType = MasterdataChangeType;

  constructor(
    protected routerService: RouterService,
    protected route: ActivatedRoute
  ) {
    this.changeType = route.snapshot?.paramMap?.get('changeType');
  }
}
